import RemoveConfirmationDialog from 'components/RemoveConfirmationDialog';
import React from 'react';
import { Badge } from 'reactstrap';

import styles from './styles.module.css';

interface BadgeWithRemoveProps {
  text: string;
  removeConfirmationTitle: string;
  removeConfirmationMessage: string;
  onRemove: () => void;
}

const BadgeWithRemove: React.FC<BadgeWithRemoveProps> = ({
  text,
  onRemove,
  removeConfirmationTitle,
  removeConfirmationMessage,
}) => {
  const [modalOpen, setModalOpen] = React.useState(false);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const handleRemove = () => {
    onRemove();
    toggleModal();
  };

  return (
    <>
      <Badge color="info" className={`${styles.bwr}`} size="md">
        {text}
        <i
          className={`fa fa-times fa-1x	${styles.removeIcon}`}
          aria-hidden="true"
          onClick={toggleModal}
        ></i>
      </Badge>
      {modalOpen && (
        <RemoveConfirmationDialog
          isOpen={modalOpen}
          toggle={toggleModal}
          removeConfirmationTitle={removeConfirmationTitle}
          removeConfirmationMessage={removeConfirmationMessage}
          onRemove={handleRemove}
        />
      )}
    </>
  );
};

export default BadgeWithRemove;
